import {
  BuyersIcon,
  EventMgmtIcon,
  VehicleInspectionLogo,
} from "../Components/IconComponents";
import IcccIcon from "../Components/IconComponents/IcccIconn";
import LmsIcon from "../Components/IconComponents/LmsIcon";
import AssetMangement from "../Components/IconComponents/AssetManagement";
import SvgUserManagementIcon from "../Components/IconComponents/UserManagementIcon";

export const modules = [
  // {
  //   name: "iccc",
  //   widgetname: "Converge ICCC",
  //   icon: <IcccIcon width="3.5rem" height="3.5rem" />,
  //   projectlink: "/client/iccc",
  //   text: "Integrated dashboard and visualization for Smart Applications",
  // },
  {
    name: "lms",
    widgetname: "LMS",
    icon: <LmsIcon width="3.5rem" height="3.5rem" />,
    projectlink: "/client/lms",
    text: "Logistic Management for Mining to automate the Sales and Production logistics operations",
  },
  // {
  //   name: "asset_management",
  //   widgetname: "Asset Management",
  //   icon: <AssetMangement width="3.5rem" height="3.5rem" />,
  //   projectlink: "http://192.168.0.3:10004",
  //   text: "Manage and Monitor installtion and operations of IoT Assets",
  // },
  {
    name: "buyer",
    widgetname: "Buyer",
    icon: <BuyersIcon width="3.5rem" height="3.5rem" />,
    projectlink: "/client/buyer",
    text: "Manage Buyers, Manage Vehicle Transportation",
  },
  {
    name: "user_management",
    widgetname: "User Management",
    icon: <SvgUserManagementIcon width="3.5rem" height="3.5rem" />,
    projectlink: "/client/user-management",
    text: "Manage Users, Use Roles and Role Permissions for the systems",
  },
  {
    name: "event_management",
    widgetname: "Event Management",
    icon: <EventMgmtIcon width="3.5rem" height="3.5rem" />,
    projectlink: "/client/event-management",
    text: "Manage event and incidents",
  },
  {
    name: "vehicle_inspection",
    widgetname: "Vehicle Inspection",
    icon: <VehicleInspectionLogo width="3.5rem" height="3.5rem" />,
    projectlink: "/client/vehicle-inspection",
    text: "Inspect vehicles",
  },
];
